{
  "https://agency-transfer-lab.miguelguerrero.eu/": {
    "state": "reachable",
    "status": 200
  },
  "https://github.com/apolmig/agencytransfer": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/blob/main/CITATION.cff": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/blob/main/METHODS.md": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/blob/main/RESPONSIBLE_RELEASE.md": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/blob/main/policy-atlas/review/source-linked-20260901/findings.md": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/blob/main/policy-atlas/review/source-linked-20260901/implementation-dossiers.md": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/blob/main/programme/reviews/20260901-draft-status-and-policy-examples.md": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/tree/main/part1b": {
    "state": "unverified",
    "status": 404
  },
  "https://github.com/apolmig/agencytransfer/tree/main/research/testing": {
    "state": "unverified",
    "status": 404
  },
  "https://huggingface.co/datasets/apol/agency-transfer-benchmark": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/datasets/apol/agency-transfer-policy-atlas": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/datasets/apol/agency-transfer-policy-atlas/tree/v0.1.0-beta.3": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/datasets/apol/ai-election-manipulation-cases": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/about/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/explainers/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/outputs/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/paper/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/references/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/references/?collection=p4-review": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/references/?scope=flagship": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/registry/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/registry/evidence/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/registry/testing/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/p4-source-linked-review-20260901.xlsx": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/part-i/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/part-ii/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/part-iii/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/part-iv/": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/references.html": {
    "state": "reachable",
    "status": 200
  },
  "https://miguelguerrero.eu/agencytransfer/research/references.json": {
    "state": "reachable",
    "status": 200
  },
  "https://a.cec.md/index.php/ro/cu-privire-la-atribuirea-mandatelor-de-deputat-in-parlamentul-republicii-2751_115476.html": {
    "state": "reachable",
    "status": 200
  },
  "https://a.cec.md/index.php/ro/cu-privire-la-centralizarea-rezultatelor-alegerilor-parlamentare-din-28-septembr-2751_115473.html": {
    "state": "reachable",
    "status": 200
  },
  "https://a.cec.md/upload/67aee6476d633/111800/attached_files": {
    "state": "reachable",
    "status": 200
  },
  "https://a.cec.md/upload/6858ff67671b8/113995/attached_files": {
    "state": "reachable",
    "status": 200
  },
  "https://a.cec.md/upload/68590e5edd817/113998/attached_files": {
    "state": "reachable",
    "status": 200
  },
  "https://a.cec.md/upload/68e657b72b3ec/115495/attached_files": {
    "state": "reachable",
    "status": 200
  },
  "https://about.fb.com/news/2024/10/taking-action-against-coordinated-inauthentic-behavior-in-moldova/": {
    "state": "reachable",
    "status": 200
  },
  "https://about.fb.com/news/2026/02/meta-prepares-for-2026-us-midterms/": {
    "state": "reachable",
    "status": 200
  },
  "https://academic.oup.com/anncom/article/50/2/109/8514202": {
    "state": "unverified",
    "status": 403
  },
  "https://academic.oup.com/jpart/article/33/1/153/6524536": {
    "state": "unverified",
    "status": 403
  },
  "https://academic.oup.com/pnasnexus/article/5/2/pgag008/8465366": {
    "state": "unverified",
    "status": 403
  },
  "https://aclanthology.org/2024.emnlp-main.312/": {
    "state": "reachable",
    "status": 200
  },
  "https://aclanthology.org/2026.acl-long.2192/": {
    "state": "reachable",
    "status": 200
  },
  "https://aclanthology.org/2026.findings-acl.1337/": {
    "state": "reachable",
    "status": 200
  },
  "https://ai-act-service-desk.ec.europa.eu/en/ai-act/annex-3": {
    "state": "reachable",
    "status": 200
  },
  "https://ai-act-service-desk.ec.europa.eu/en/ai-act/article-27": {
    "state": "reachable",
    "status": 200
  },
  "https://ai-act-service-desk.ec.europa.eu/en/ai-act/article-51": {
    "state": "reachable",
    "status": 200
  },
  "https://ai-act-service-desk.ec.europa.eu/sites/default/files/2025-08/guidelines_on_prohibited_artificial_intelligence_practices_established_by_regulation_eu_20241689_ai_act_english_ied3r5nwo50xggpcfmwckm3nuc_112367-1.PDF": {
    "state": "reachable",
    "status": 200
  },
  "https://ai.google.dev/gemini-api/docs/models/gemini-2.5-pro": {
    "state": "reachable",
    "status": 200
  },
  "https://ai.google.dev/gemini-api/docs/models/gemini-3.1-flash-lite": {
    "state": "reachable",
    "status": 200
  },
  "https://ai.meta.com/blog/llama-4-multimodal-intelligence/": {
    "state": "reachable",
    "status": 200
  },
  "https://ainowinstitute.org/publications/research/ai-now-2025-landscape-report": {
    "state": "reachable",
    "status": 200
  },
  "https://algorithmic-transparency.ec.europa.eu/about_en": {
    "state": "reachable",
    "status": 200
  },
  "https://algorithmic-transparency.ec.europa.eu/news/faqs-dsa-data-access-researchers-2025-07-03_en": {
    "state": "reachable",
    "status": 200
  },
  "https://api-docs.deepseek.com/news/news250120/": {
    "state": "reachable",
    "status": 200
  },
  "https://api-docs.deepseek.com/news/news250528/": {
    "state": "reachable",
    "status": 200
  },
  "https://api-docs.deepseek.com/news/news260424/": {
    "state": "reachable",
    "status": 200
  },
  "https://apnews.com/article/ai-robocalls-biden-new-hampshire-7bb71c5ab962760995469c3b6f787a86": {
    "state": "unverified",
    "status": 403
  },
  "https://apnews.com/article/ai-robocalls-new-hampshire-biden-kramer-e87ef8848a2a6515202535a6e800da07": {
    "state": "unverified",
    "status": 403
  },
  "https://apnews.com/article/e87ef8848a2a6515202535a6e800da07": {
    "state": "unverified",
    "status": 403
  },
  "https://artificialintelligenceact.eu/introduction-to-code-of-practice/": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/1909.08740": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2012.05370": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2102.09692": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2112.00773": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2301.04246": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2302.00560": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2303.09387": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2303.11074": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2304.09848": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2307.03744": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2307.07960": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2308.16364": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2310.11986": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2310.13548": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2312.15524": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2404.12626": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2404.15058": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2405.21015": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2406.07814": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2406.13352": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2406.13843": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2406.14508": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2406.18382": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2408.04681": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2410.17361": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2410.21514": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2410.21572": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2411.08088": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2411.14652": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2412.17618": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2502.07663": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2503.02857": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2503.03750": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2503.17473": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2503.17473v2": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2503.18813v2": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2504.06435": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2504.09865": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2504.09865v2": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2504.10430": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2505.00036": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2505.04345": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2505.18003": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2505.18333": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2505.22961": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2506.02873": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2506.06800": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2507.12872": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2507.13919": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2508.19258": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2509.05219": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2509.19515": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2512.01431": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2512.12856": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2512.22894": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2601.05050": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2601.07072": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2602.03117": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2602.18455": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.02960": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.08760": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.09884": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.15125": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.20907": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.25326": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2603.27413": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2604.04263": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2604.04263v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2604.08525": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2604.09200": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2604.22503": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2604.24890": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2605.14021": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2605.14097": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2606.02754": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2606.03271": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2606.05330": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2606.06099": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2606.16475": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2606.21317v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2607.28503": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2608.21841": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/abs/2608.21841v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2503.18813v2": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2512.00193v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2604.04263v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2604.04721v2": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2605.28908v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2606.21317v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2607.28503v2": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/html/2608.21841v1": {
    "state": "reachable",
    "status": 200
  },
  "https://arxiv.org/pdf/2509.12517": {
    "state": "reachable",
    "status": 200
  },
  "https://blog.google/innovation-and-ai/models-and-research/gemini-models/gemini-3-1-pro/": {
    "state": "reachable",
    "status": 200
  },
  "https://blog.google/innovation-and-ai/models-and-research/gemini-models/gemini-3-6-flash-3-5-flash-lite-3-5-flash-cyber/": {
    "state": "reachable",
    "status": 200
  },
  "https://blog.google/technology/ai/google-gemini-ai/": {
    "state": "reachable",
    "status": 200
  },
  "https://blog.google/technology/google-deepmind/gemini-3/": {
    "state": "not_found",
    "status": 404
  },
  "https://c2pa.org/specifications/specifications/2.0/security/Security_Considerations.html": {
    "state": "reachable",
    "status": 200
  },
  "https://carnegieendowment.org/research/2025/09/ai-agents-and-democratic-resilience": {
    "state": "reachable",
    "status": 200
  },
  "https://cdn.osce.org/sites/default/files/f/documents/9/d/578815_0.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://cdn.sanity.io/files/4zrzovbb/website/037f06850df7fbe871e206dad004c3db5fd50340.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://cdt.org/insights/dark-patterns-in-ai-chatbots-a-taxonomy-to-inform-better-design/": {
    "state": "unverified",
    "status": 403
  },
  "https://cetas.turing.ac.uk/publications/ai-enabled-influence-operations-threat-analysis-2024-uk-and-european-elections": {
    "state": "unverified",
    "status": 403
  },
  "https://cetas.turing.ac.uk/sites/default/files/2024-09/cetas_briefing_paper_-_ai-enabled_influence_operations_-_threat_analysis_of_the_2024_uk_and_european_elections.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://commission.europa.eu/european-centre-democratic-resilience_en": {
    "state": "reachable",
    "status": 200
  },
  "https://commission.europa.eu/law/law-topic/consumer-protection-law/review-eu-consumer-law_en": {
    "state": "reachable",
    "status": 200
  },
  "https://commission.europa.eu/news-and-media/news/new-eu-rules-political-advertising-come-effect-2025-10-10_en": {
    "state": "reachable",
    "status": 200
  },
  "https://competition-policy.ec.europa.eu/document/download/c86d461f-062e-4dde-a662-15228d6ca385_en": {
    "state": "reachable",
    "status": 200
  },
  "https://constcourt.md/ccdocview.php?docid=866&l=ro&tip=hotariri": {
    "state": "reachable",
    "status": 200
  },
  "https://constcourt.md/ccdocview.php?docid=867&l=ro&tip=hotariri": {
    "state": "reachable",
    "status": 200
  },
  "https://constcourt.md/ccdocview.php?docid=882&l=ro&tip=hotariri": {
    "state": "reachable",
    "status": 200
  },
  "https://dadosabertos.tse.jus.br/api/3/action/package_search?q=resultados%202026": {
    "state": "reachable",
    "status": 200
  },
  "https://dadosabertos.tse.jus.br/dataset/candidatos-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://dadosabertos.tse.jus.br/dataset/eleitorado-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://data-access.dsa.ec.europa.eu/home": {
    "state": "reachable",
    "status": 200
  },
  "https://deepmind.google/blog/protecting-people-from-harmful-manipulation/": {
    "state": "reachable",
    "status": 200
  },
  "https://deepmind.google/discover/blog/strengthening-our-frontier-safety-framework/": {
    "state": "reachable",
    "status": 200
  },
  "https://deepmind.google/frontier-safety/": {
    "state": "reachable",
    "status": 200
  },
  "https://deepmind.google/models/model-cards/gemini-3-1-pro/": {
    "state": "reachable",
    "status": 200
  },
  "https://deepmind.google/research/publications/224297/": {
    "state": "reachable",
    "status": 200
  },
  "https://demtech.oii.ox.ac.uk/research/posts/the-global-disinformation-order-2019-global-inventory-of-organised-social-media-manipulation/": {
    "state": "reachable",
    "status": 200
  },
  "https://dfrlab.org/2025/08/26/cross-platform-campaign-accuses-moldovas-sandu-of-meddling-in-romanian-elections/": {
    "state": "reachable",
    "status": 200
  },
  "https://dfrlab.org/2025/09/24/paid-to-post-russia-linked-digital-army-seeks-to-undermine-moldovan-election/": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-markets-act.ec.europa.eu/about-dma/dma-review-qa_en": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-markets-act.ec.europa.eu/developer-portal/interoperability/alphabet-specification-proceedings-interoperability-ai-services_en": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/faqs/digital-services-act-questions-and-answers": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/faqs/general-purpose-ai-models-ai-act-questions-answers": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/faqs/navigating-ai-act": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/faqs/transparency-obligations-under-article-50-ai-act": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/library/code-conduct-disinformation": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/library/commission-publishes-guidelines-prohibited-artificial-intelligence-ai-practices-defined-ai-act": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/library/delegated-act-data-access-under-digital-services-act-dsa": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/library/dsa-elections-toolkit-digital-services-coordinators": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/library/guidelines-providers-vlops-and-vloses-mitigation-systemic-risks-electoral-processes": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/news/commission-designates-chatgpt-reddit-roblox-under-digital-services-act": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/news/commission-opens-formal-proceedings-against-tiktok-election-risks-under-digital-services-act": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/news/commission-presents-new-best-practice-election-toolkit-digital-services-act": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/news/commission-publishes-guidelines-under-dsa-mitigation-systemic-risks-online-elections": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/news/third-gpai-signatory-taskforce-meeting-safety-and-security-chapter": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/ai-act-complaints-tool": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/code-practice-ai-generated-content": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/code-practice-disinformation": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/contents-code-gpai": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/dsa-brings-transparency": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/dsa-codes-conduct": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/guidelines-ai-transparency-obligations": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/guidelines-gpai-providers": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/list-designated-vlops-and-vloses": {
    "state": "reachable",
    "status": 200
  },
  "https://digital-strategy.ec.europa.eu/en/policies/regulatory-framework-ai": {
    "state": "reachable",
    "status": 200
  },
  "https://dl.acm.org/doi/10.1145/3359183": {
    "state": "unverified",
    "status": 403
  },
  "https://dl.acm.org/doi/10.1145/3584931.3606969": {
    "state": "unverified",
    "status": 403
  },
  "https://dl.acm.org/doi/10.1145/3706598.3713429": {
    "state": "unverified",
    "status": 403
  },
  "https://docs.fcc.gov/public/attachments/DA-24-790A1.txt": {
    "state": "reachable",
    "status": 200
  },
  "https://docs.fcc.gov/public/attachments/FCC-24-104A1.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://docs.fcc.gov/public/attachments/FCC-24-17A1.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://docs.fcc.gov/public/attachments/FCC-24-60A1.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://docs.justia.com/cases/federal/district-courts/california/caedce/2%3A2024cv02527/453046/98": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1016/j.ijresmar.2025.03.002": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1017/S0003055417000363": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1017/XPS.2026.10032": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41467-022-30073-5": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41467-022-35576-9": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41467-025-61345-5": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41562-020-0833-x": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41562-023-01564-2": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41562-024-02023-2": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41562-025-02194-6": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41586-021-03344-2": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41586-024-07524-8": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41586-024-08025-4": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41586-025-09771-9": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41586-026-10098-2": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41598-024-53755-0": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1038/s41598-025-30783-y": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1073/pnas.1710966114": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1073/pnas.2216261120": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1073/pnas.2322823121": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1073/pnas.2412815122": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1073/pnas.2413443122": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1073/pnas.2503413122": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1073/pnas.2600635123": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1080/10584609.2020.1868633": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1080/1369118X.2016.1186713": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1093/ct/qtad006": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1093/ej/ueae027": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1093/jla/laaa006": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1093/modernlaw/fkaa052": {
    "state": "not_found",
    "status": 404
  },
  "https://doi.org/10.1093/pnasnexus/pgae035": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1093/pnasnexus/pgae247": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1093/qje/qjt024": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1109/PST58708.2023.10320197": {
    "state": "reachable",
    "status": 202
  },
  "https://doi.org/10.1109/SP40000.2020.00084": {
    "state": "reachable",
    "status": 202
  },
  "https://doi.org/10.1111/1756-2171.12455": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1111/j.1540-6261.2010.01614.x": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1111/pops.70015": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/sciadv.abo6254": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/sciadv.adh1850": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/sciadv.adv3758": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/science.abp9364": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/science.ade7138": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/science.adl2829": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/science.adq1814": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1126/science.aea3884": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1145/3313831.3376321": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1145/3397271.3401034": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1145/3706598.3713171": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1145/3719160.3736610": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1145/3800687": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1177/02633957231156084": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1177/09567976241232905": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1177/1461444820934033": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1177/14614448221142007": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1177/19401612251317766": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1177/20563051261449194": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1371/journal.pone.0317421": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.14488/BJOPM.2591.2026": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.14763/2019.2.1410": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.1609/icwsm.v18i1.31372": {
    "state": "unverified",
    "status": null
  },
  "https://doi.org/10.1787/658c2ad6-en": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.1787/e7e88884-en": {
    "state": "unverified",
    "status": 403
  },
  "https://doi.org/10.18352/ulr.420": {
    "state": "unverified",
    "status": null
  },
  "https://doi.org/10.2478/popets-2021-0051": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.3386/w33410": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.48550/arXiv.2404.15058": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.48550/arXiv.2506.02873": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.48550/arXiv.2507.12872": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.6028/NIST.AI.600-1": {
    "state": "reachable",
    "status": 200
  },
  "https://doi.org/10.7551/mitpress/14962.003.0004": {
    "state": "unverified",
    "status": 403
  },
  "https://dq4n3btxmr8c9.cloudfront.net/files/uz6rz9/LIBERTIES_AI_and_ELECTIONS_2026_04_2007_FINAL.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://ec.europa.eu/newsroom/dae/redirection/document/118119": {
    "state": "reachable",
    "status": 200
  },
  "https://edmo.eu/publications/edmos-assessment-of-the-rapid-response-system-of-the-code-of-practice-on-disinformation/": {
    "state": "reachable",
    "status": 202
  },
  "https://eur-lex.europa.eu/eli/reg/2016/679/oj": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2016/679/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2022/1925/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2022/2065/oj": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2022/2065/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2023/2854/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2024/1083/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2024/1689/oj": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2024/1689/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2024/900/oj": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2024/900/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg/2026/1744/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/eli/reg_impl/2026/818/oj/eng": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:52024XC03014": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX%3A02024R1689-20260727": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX%3A52021XC1229%2805%29": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX%3A52025DC0870": {
    "state": "reachable",
    "status": 200
  },
  "https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:02024R1689-20260727": {
    "state": "reachable",
    "status": 200
  },
  "https://faq.whatsapp.com/1053543185312573": {
    "state": "reachable",
    "status": 200
  },
  "https://firstmonday.org/ojs/index.php/fm/article/view/4901": {
    "state": "unverified",
    "status": null
  },
  "https://freedomhouse.org/report/freedom-net/2023/repressive-power-artificial-intelligence": {
    "state": "reachable",
    "status": 200
  },
  "https://gc.nh.gov/rsa/html/LXIII/659/659-73.htm": {
    "state": "reachable",
    "status": 200
  },
  "https://georgetownlawtechreview.org/online-manipulation-hidden-influences-in-a-digital-world/GLTR-01-2020/": {
    "state": "reachable",
    "status": 200
  },
  "https://github.com/AlignmentResearch/AttemptPersuadeEval": {
    "state": "reachable",
    "status": 200
  },
  "https://github.com/alan-turing-institute/election-ai-safety": {
    "state": "reachable",
    "status": 200
  },
  "https://global.oup.com/academic/product/computational-propaganda-9780190931407": {
    "state": "reachable",
    "status": 202
  },
  "https://help.aliyun.com/zh/model-studio/models": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/MiniMaxAI/MiniMax-M3": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/Qwen/Qwen1.5-110B-Chat": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/Qwen/Qwen3-235B-A22B": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/Qwen/Qwen3-Coder-480B-A35B-Instruct": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/Qwen/Qwen3.5-397B-A17B": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/bigscience/bloomz": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/deepseek-ai/DeepSeek-R1": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/deepseek-ai/DeepSeek-V3": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/deepseek-ai/DeepSeek-V3.2": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/deepseek-ai/DeepSeek-V4-Flash-0731": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/meta-llama/Llama-3.1-405B-Instruct": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/mistralai/Mixtral-8x22B-Instruct-v0.1": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/moonshotai/Kimi-K2-Instruct": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/moonshotai/Kimi-K2-Instruct-0905": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/moonshotai/Kimi-K2.5": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/moonshotai/Kimi-K3": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/openai/gpt-oss-120b": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/tiiuae/falcon-180B-chat": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/zai-org/GLM-4.5": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/zai-org/GLM-5": {
    "state": "reachable",
    "status": 200
  },
  "https://huggingface.co/zai-org/GLM-5.2": {
    "state": "reachable",
    "status": 200
  },
  "https://ico.org.uk/media2/migrated/2260271/investigation-into-the-use-of-data-analytics-in-political-campaigns-final-20181105.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://ijoc.org/index.php/ijoc/article/view/20777": {
    "state": "reachable",
    "status": 200
  },
  "https://internationalaisafetyreport.org/publication/international-ai-safety-report-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0317421": {
    "state": "reachable",
    "status": 200
  },
  "https://journals.sagepub.com/doi/10.1177/20563051231186353": {
    "state": "unverified",
    "status": 403
  },
  "https://knightcolumbia.org/content/dont-panic-yet-assessing-the-evidence-and-discourse-around-generative-ai-and-elections": {
    "state": "reachable",
    "status": 200
  },
  "https://ks.echr.coe.int/documents/d/echr-ks/guide_art_9_eng": {
    "state": "unverified",
    "status": 403
  },
  "https://leginfo.legislature.ca.gov/faces/billTextClient.xhtml?bill_id=202520260SB53": {
    "state": "reachable",
    "status": 200
  },
  "https://legislatie.just.ro/Public/DetaliiDocumentAfis/292099": {
    "state": "unverified",
    "status": null
  },
  "https://legislatie.just.ro/public/DetaliiDocument/291969": {
    "state": "unverified",
    "status": null
  },
  "https://missionlocal.org/2026/08/sf-scott-wiener-connie-chan-ai-chatbot/": {
    "state": "reachable",
    "status": 200
  },
  "https://mistral.ai/news/mistral-3/": {
    "state": "reachable",
    "status": 200
  },
  "https://newsroom.tiktok.com/en-eu/continuing-to-protect-the-integrity-of-tiktok-during-romanian-elections": {
    "state": "reachable",
    "status": 200
  },
  "https://nvlpubs.nist.gov/nistpubs/ai/NIST.AI.600-1.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://odihr.osce.org/odihr/597450": {
    "state": "reachable",
    "status": 200
  },
  "https://odihr.osce.org/odihr/662251": {
    "state": "reachable",
    "status": 200
  },
  "https://odihr.osce.org/odihr/elections/moldova/587451": {
    "state": "reachable",
    "status": 200
  },
  "https://odihr.osce.org/sites/default/files/f/documents/f/3/600295_0.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://ojs.aaai.org/index.php/AAAI/article/view/30349/32389": {
    "state": "unverified",
    "status": null
  },
  "https://ojs.aaai.org/index.php/IASEAI/article/view/43027": {
    "state": "unverified",
    "status": null
  },
  "https://open.clemson.edu/mfh_reports/7/": {
    "state": "reachable",
    "status": 200
  },
  "https://openai.com/index/disrupting-deceptive-uses-of-ai-by-covert-influence-operations/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/disrupting-malicious-uses-of-ai/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/gpt-4-research/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/gpt-5-6/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/introducing-gpt-5-2/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/introducing-gpt-5-4/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/introducing-gpt-5-5/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/introducing-gpt-5/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/introducing-o3-and-o4-mini/": {
    "state": "unverified",
    "status": 403
  },
  "https://openai.com/index/openai-frontier-governance-framework/": {
    "state": "unverified",
    "status": 403
  },
  "https://openfuture.eu/our-work/ai-and-the-commons/": {
    "state": "reachable",
    "status": 200
  },
  "https://openreview.net/forum?id=aTCXvJKnkE": {
    "state": "reachable",
    "status": 200
  },
  "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3306006": {
    "state": "unverified",
    "status": 403
  },
  "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4669971": {
    "state": "unverified",
    "status": 403
  },
  "https://prezenta.roaep.ro/prezidentiale04052025/data/json/sicpv/pv/pv.json": {
    "state": "unverified",
    "status": null
  },
  "https://prezenta.roaep.ro/prezidentiale18052025/data/json/sicpv/pv/pv.json": {
    "state": "unverified",
    "status": null
  },
  "https://prezenta.roaep.ro/prezidentiale24112024/data/json/sicpv/pv/pv.json": {
    "state": "unverified",
    "status": null
  },
  "https://proceedings.mlr.press/v267/longpre25a.html": {
    "state": "reachable",
    "status": 200
  },
  "https://public-buyers-community.ec.europa.eu/communities/procurement-ai/resources/updated-eu-ai-model-contractual-clauses": {
    "state": "reachable",
    "status": 200
  },
  "https://publications.parliament.uk/pa/cm201719/cmselect/cmcumeds/1791/1791.pdf": {
    "state": "unverified",
    "status": 403
  },
  "https://purl.stanford.edu/tr171zs0069": {
    "state": "reachable",
    "status": 200
  },
  "https://qwenlm.github.io/blog/qwen3/": {
    "state": "reachable",
    "status": 200
  },
  "https://restofworld.org/2024/tracking-global-election-ai/": {
    "state": "reachable",
    "status": 200
  },
  "https://rm.coe.int/1680afae3c": {
    "state": "unverified",
    "status": 403
  },
  "https://rm.coe.int/cai-2024-16rev2-methodology-for-the-risk-and-impact-assessment-of-arti/1680b2a09f": {
    "state": "unverified",
    "status": 403
  },
  "https://sf.gazetteer.co/a-parody-connie-chan-chatbot-is-scott-wieners-newest-tactic": {
    "state": "reachable",
    "status": 200
  },
  "https://siepr.stanford.edu/publications/working-paper/sources-market-power-web-search-evidence-field-experiment": {
    "state": "reachable",
    "status": 200
  },
  "https://snoop.ro/anaf-a-descoperit-ca-pnl-a-platit-o-campanie-care-l-a-promovat-masiv-pe-calin-georgescu-pe-tiktok/": {
    "state": "reachable",
    "status": 200
  },
  "https://spec.c2pa.org/": {
    "state": "reachable",
    "status": 200
  },
  "https://spec.c2pa.org/specifications/specifications/2.2/specs/C2PA_Specification.html": {
    "state": "reachable",
    "status": 200
  },
  "https://spec.c2pa.org/specifications/specifications/2.4/specs/C2PA_Specification.html": {
    "state": "reachable",
    "status": 200
  },
  "https://static.congressoemfoco.com.br/2026/07/27/attachment/2026/07/27/cd5726_tse_fe_brasil_ia_jair_convencao_pl_26_jul__2026.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://storage.googleapis.com/deepmind-media/DeepMind.com/Blog/strengthening-our-frontier-safety-framework/frontier-safety-framework_3-1.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://syntheticmedia.partnershiponai.org/": {
    "state": "reachable",
    "status": 200
  },
  "https://unesdoc.unesco.org/ark:/48223/pf0000387339": {
    "state": "unverified",
    "status": 403
  },
  "https://uscode.house.gov/view.xhtml?edition=prelim&num=0&req=granuleid%3AUSC-prelim-title2-section7": {
    "state": "reachable",
    "status": 200
  },
  "https://utrechtlawreview.org/articles/10.18352/ulr.420": {
    "state": "unverified",
    "status": null
  },
  "https://www-cdn.anthropic.com/0b4915911bb0d19eca5b5ee635c80fef830a37ea.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www-cdn.anthropic.com/53566bf5440a10affd749724787c8913a2ae0841.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www-cdn.anthropic.com/9e6a1044980d8c4ed85669faf9c2a8342e2e9f1e/Claude%20Sonnet%205%20System%20Card.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.aisi.gov.uk/blog/inspect-evals": {
    "state": "reachable",
    "status": 200
  },
  "https://www.aisi.gov.uk/research": {
    "state": "reachable",
    "status": 200
  },
  "https://www.aisi.gov.uk/research-agenda": {
    "state": "reachable",
    "status": 200
  },
  "https://www.alibabacloud.com/help/en/model-studio/newly-released-models": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/news/claude-4": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/news/claude-fable-5-mythos-5": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/news/claude-opus-4-5": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/news/claude-opus-4-7": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/news/claude-opus-5": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/news/claude-sonnet-5": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/research/disempowerment-patterns": {
    "state": "reachable",
    "status": 200
  },
  "https://www.anthropic.com/research/malicious-agentic-influence-campaigns": {
    "state": "not_found",
    "status": 404
  },
  "https://www.anthropic.com/research/measuring-model-persuasiveness": {
    "state": "reachable",
    "status": 200
  },
  "https://www.axios.com/local/san-francisco/2026/08/11/sf-scott-wiener-connie-chan-pelosi-ai-chatbot": {
    "state": "unverified",
    "status": 403
  },
  "https://www.beuc.eu/reports/synthetic-empathy-risks-and-rights-artificial-companionship": {
    "state": "reachable",
    "status": 200
  },
  "https://www.brennancenter.org/our-work/research-reports/does-ai-fight-or-fuel-election-disinformation": {
    "state": "reachable",
    "status": 200
  },
  "https://www.brookings.edu/articles/how-public-ai-can-strengthen-democracy/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.cac.gov.cn/2023-07/13/c_1690898327029107.htm": {
    "state": "reachable",
    "status": 200
  },
  "https://www.canada.ca/en/government/system/digital-government/digital-government-innovations/responsible-use-ai/algorithmic-impact-assessment.html": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ccr.ro/en/press-release-6-dec/": {
    "state": "unverified",
    "status": null
  },
  "https://www.ccr.ro/wp-content/uploads/2025/04/SUMMARY-OF-THE-CASES-DELIVERED.pdf": {
    "state": "unverified",
    "status": null
  },
  "https://www.ccr.ro/wp-content/uploads/2025/05/Hotarare_39_2025.pdf": {
    "state": "unverified",
    "status": null
  },
  "https://www.ccr.ro/wp-content/uploads/2025/05/Hotarare_43_2025.pdf": {
    "state": "unverified",
    "status": null
  },
  "https://www.ccr.ro/wp-content/uploads/2025/05/Hotarare_44_2025.pdf": {
    "state": "unverified",
    "status": null
  },
  "https://www.cisa.gov/resources-tools/resources/election-security-cisa-tabletop-exercise-packages-cteps": {
    "state": "unverified",
    "status": 403
  },
  "https://www.cisa.gov/resources-tools/resources/risk-focus-generative-ai-and-2024-election-cycle": {
    "state": "unverified",
    "status": 403
  },
  "https://www.coe.int/en/web/Conventions/full-list/?module=signatures-by-treaty&treatynum=225": {
    "state": "unverified",
    "status": 403
  },
  "https://www.coe.int/en/web/artificial-intelligence/-/european-union-ratifies-the-council-of-europe-framework-convention-on-artificial-intelligence": {
    "state": "unverified",
    "status": 403
  },
  "https://www.coe.int/en/web/artificial-intelligence/huderia-risk-and-impact-assessment-of-ai-systems": {
    "state": "unverified",
    "status": 403
  },
  "https://www.coe.int/en/web/artificial-intelligence/the-framework-convention-on-artificial-intelligence": {
    "state": "unverified",
    "status": 403
  },
  "https://www.consilium.europa.eu/en/policies/sanctions-against-moldova/": {
    "state": "unverified",
    "status": 403
  },
  "https://www.constcourt.md/ccdocview.php?docid=866&l=ro&tip=hotariri": {
    "state": "reachable",
    "status": 200
  },
  "https://www.dataprivacybr.org/en/documentos/ai-in-the-2024-brazilian-elections/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.doj.nh.gov/news-and-media/steven-kramer-charged-voter-suppression-over-ai-generated-president-biden-robocalls": {
    "state": "reachable",
    "status": 200
  },
  "https://www.eac.gov/sites/default/files/2026-02/2024_EAVS_for_Public_Release_nolabel_V2_csv.zip": {
    "state": "reachable",
    "status": 200
  },
  "https://www.edpb.europa.eu/documents/guideline/guidelines-82020-on-the-targeting-of-social-media-users_en": {
    "state": "reachable",
    "status": 200
  },
  "https://www.edpb.europa.eu/documents/statement/statement-22019-on-the-use-of-personal-data-in-the-course-of-political_en": {
    "state": "reachable",
    "status": 200
  },
  "https://www.eeas.europa.eu/sites/default/files/2025/documents/2024%20Report%20on%20EEAS%20Activities%20to%20Counter%20FIMI.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.eeas.europa.eu/sites/default/files/documents/2024/EEAS-2nd-Report%20on%20FIMI%20Threats-January-2024_0.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.eecs.harvard.edu/~kgajos/papers/2021/bucinca21trust.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.electoralcommission.org.uk/full-guidance/statutory-guidance-digital-imprints": {
    "state": "unverified",
    "status": 403
  },
  "https://www.electoralcommission.org.uk/media-centre/electoral-commission-launches-deepfake-detection-pilot-counter-ai-misinformation": {
    "state": "unverified",
    "status": 403
  },
  "https://www.electoralcommission.org.uk/news-and-views/our-responses-consultations/response-science-innovation-and-technology-committee-call-evidence-social-media-misinformation-and": {
    "state": "unverified",
    "status": 403
  },
  "https://www.fcc.gov/document/fcc-issues-6m-fine-nh-robocalls": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fcc.gov/document/fcc-makes-ai-generated-voices-robocalls-illegal": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fcc.gov/document/fcc-proposes-6-million-fine-deepfake-robocalls-around-nh-primary": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fcc.gov/document/fcc-proposes-disclosure-ai-generated-content-political-ads": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fcc.gov/document/fcc-settles-spoofed-ai-generated-robocalls-case": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fec.gov/documents/5910/2026pdates.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fec.gov/files/bulk-downloads/2026/cn26.zip": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fec.gov/resources/cms-content/documents/2026pdates.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fec.gov/updates/commission-approves-notification-of-disposition-interpretive-rule-on-artificial-intelligence-in-campaign-ads/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.federalregister.gov/documents/2024/01/29/2024-01580/taking-additional-steps-to-address-the-national-emergency-with-respect-to-significant-malicious": {
    "state": "reachable",
    "status": 200
  },
  "https://www.fema.gov/emergency-managers/national-preparedness/exercises/hseep": {
    "state": "unverified",
    "status": 403
  },
  "https://www.ft.com/content/e18c380f-c25d-4e91-8135-d9c2424ab720": {
    "state": "unverified",
    "status": 403
  },
  "https://www.ftc.gov/legal-library/browse/cases-proceedings/182-3107-cambridge-analytica-llc-matter": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ftc.gov/news-events/news/press-releases/2019/12/ftc-issues-opinion-order-against-cambridge-analytica-deceiving-consumers-about-collection-facebook": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ftc.gov/news-events/news/press-releases/2025/01/ftc-issues-staff-report-ai-partnerships-investments-study": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ftc.gov/reports/ftc-staff-report-ai-partnerships-investments-6b-study": {
    "state": "reachable",
    "status": 200
  },
  "https://www.gov.uk/cma-cases/cloud-services-market-investigation": {
    "state": "reachable",
    "status": 200
  },
  "https://www.gov.uk/government/publications/ai-playbook-for-the-uk-government/artificial-intelligence-playbook-for-the-uk-government-html": {
    "state": "reachable",
    "status": 200
  },
  "https://www.gov.uk/government/publications/algorithmic-transparency-recording-standard-mandatory-scope-and-exemptions-policy/algorithmic-transparency-recording-standard-atrs-mandatory-scope-and-exemptions-policy": {
    "state": "reachable",
    "status": 200
  },
  "https://www.gov.uk/government/publications/frontier-ai-safety-commitments-ai-seoul-summit-2024/frontier-ai-safety-commitments-ai-seoul-summit-2024": {
    "state": "reachable",
    "status": 200
  },
  "https://www.gov.uk/government/publications/joint-statement-on-competition-in-generative-ai-foundation-models-and-ai-products/joint-statement-on-competition-in-generative-ai-foundation-models-and-ai-products": {
    "state": "reachable",
    "status": 200
  },
  "https://www.governor.ny.gov/news/governor-hochul-signs-legislation-expanding-historic-empire-ai-consortium-and-establishing": {
    "state": "reachable",
    "status": 200
  },
  "https://www.idea.int/european-code-of-conduct-2024": {
    "state": "reachable",
    "status": 200
  },
  "https://www.idea.int/publications/catalogue/artificial-intelligence-electoral-management": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ifes.org/publications/romanian-2024-election-annulment-addressing-emerging-threats-electoral-integrity": {
    "state": "unverified",
    "status": 403
  },
  "https://www.ischool.berkeley.edu/news/presscoverage/2026/hany-farid-delves-newly-released-deepfakes-james-talarico": {
    "state": "reachable",
    "status": 200
  },
  "https://www.iso.org/standard/42001": {
    "state": "unverified",
    "status": 403
  },
  "https://www.legislation.gov.uk/ukpga/2023/50/contents": {
    "state": "reachable",
    "status": 200
  },
  "https://www.lwv.org/legal-center/league-women-voters-new-hampshire-v-kramer": {
    "state": "unverified",
    "status": 403
  },
  "https://www.mask-benchmark.ai/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.minimax.io/news/minimax-m21": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41467-024-51998-z": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41467-025-61345-5": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41562-022-01460-1": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41562-025-02194-6": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41562-025-02309-z": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41586-021-03344-2": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41586-025-09771-9": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41586-026-10098-2": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s41598-024-53755-0": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s44271-025-00188-8": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nature.com/articles/s44271-025-00381-9": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nber.org/papers/w33139": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ncsl.org/elections-and-campaigns/artificial-intelligence-ai-in-elections-and-campaigns": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nhpr.org/nh-news/2025-06-13/political-operative-fake-biden-robocalls-nh-primary-found-not-guilty": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nist.gov/artificial-intelligence/ai-agent-standards-initiative": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nist.gov/itl/ai-risk-management-framework": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nist.gov/publications/challenges-monitoring-deployed-ai-systems-center-ai-standards-and-innovation": {
    "state": "reachable",
    "status": 200
  },
  "https://www.nrsc.org/press-releases/new-ad-james-talarico-reads-his-most-memorable-tweets-2026-03-11/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.ntia.gov/programs-and-initiatives/artificial-intelligence/open-model-weights-report": {
    "state": "unverified",
    "status": null
  },
  "https://www.odni.gov/files/FMIC/documents/ODNI-Election-Security-Update-20241021.pdf": {
    "state": "reachable",
    "status": 200
  },
  "https://www.oecd.org/en/about/news/press-releases/2025/02/oecd-launches-global-framework-to-monitor-application-of-g7-hiroshima-ai-code-of-conduct.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.oecd.org/en/about/news/press-releases/2026/05/oecd-launches-streamlined-hiroshima-ai-process-reporting-framework-to-help-small-and-medium-sized-enterprises-participate.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.oecd.org/en/publications/artificial-intelligence-markets_d531d73f-en/full-report.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.oecd.org/en/publications/digital-government-outlook_0496b2bc-en/full-report/adopting-and-governing-ai-in-government_7ef312a9.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.oecd.org/en/publications/facts-not-fakes_1a27f2b5-en.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.oecd.org/en/topics/sub-issues/ai-principles.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.ofcom.org.uk/online-safety/illegal-and-harmful-content/ai-chatbots-and-online-regulation-what-you-need-to-know": {
    "state": "unverified",
    "status": 403
  },
  "https://www.osce.org/odihr/elections/moldova": {
    "state": "reachable",
    "status": 200
  },
  "https://www.osce.org/odihr/elections/romania": {
    "state": "reachable",
    "status": 200
  },
  "https://www.pnas.org/doi/10.1073/pnas.2403116121": {
    "state": "unverified",
    "status": 403
  },
  "https://www.pnas.org/doi/10.1073/pnas.2515516122": {
    "state": "unverified",
    "status": 403
  },
  "https://www.poder360.com.br/poder-justica/kassio-marca-reuniao-com-ministros-do-tse-para-definir-ia-de-bolsonaro/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.presidency.ro/files/userfiles/Documente%20CSAT/Document%20CSAT%20SRI%20I.pdf": {
    "state": "unverified",
    "status": null
  },
  "https://www.proofnews.org/ai-models-falter-answering-election-questions-in-spanish/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.proofnews.org/how-we-tested-leading-ai-models-performance-on-election-queries/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.rand.org/pubs/research_reports/RRA4817-1.html": {
    "state": "unverified",
    "status": 403
  },
  "https://www.reuters.com/business/media-telecom/ai-deepfakes-blur-reality-2026-us-midterm-campaigns-2026-03-28/": {
    "state": "unverified",
    "status": 401
  },
  "https://www.reuters.com/business/media-telecom/brazils-bolsonaro-is-barred-this-years-election-can-his-ai-avatar-campaign-2026-07-28/": {
    "state": "unverified",
    "status": 401
  },
  "https://www.reuters.com/technology/artificial-intelligence/meta-says-gen-ai-had-muted-impact-global-elections-this-year-2024-12-03/": {
    "state": "unverified",
    "status": 401
  },
  "https://www.reuters.com/world/europe/moldova-police-say-businessman-shor-channelled-24-million-pay-off-voters-2024-10-24/": {
    "state": "unverified",
    "status": 401
  },
  "https://www.ruizlab.org/publications/characterizing-user-comprehension-in-the-stir-shaken-anti-robocall-standard/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.science.org/doi/10.1126/sciadv.adw5578": {
    "state": "unverified",
    "status": 403
  },
  "https://www.science.org/doi/10.1126/science.abp9364": {
    "state": "unverified",
    "status": 403
  },
  "https://www.science.org/doi/10.1126/science.adq1814": {
    "state": "unverified",
    "status": 403
  },
  "https://www.science.org/doi/10.1126/science.adu0592": {
    "state": "unverified",
    "status": 403
  },
  "https://www.science.org/doi/10.1126/science.adu5584": {
    "state": "unverified",
    "status": 403
  },
  "https://www.science.org/doi/10.1126/science.aea3884": {
    "state": "unverified",
    "status": 403
  },
  "https://www.science.org/doi/10.1126/science.aec8352": {
    "state": "unverified",
    "status": 403
  },
  "https://www.sfgate.com/politics/article/scott-wiener-anthropic-billboard-22372638.php": {
    "state": "reachable",
    "status": 200
  },
  "https://www.sos.nh.gov/2024-democratic-presidential-primary-election-results": {
    "state": "reachable",
    "status": 200
  },
  "https://www.sos.nh.gov/sites/g/files/ehbemt561/files/inline-documents/sonh/2024-pp-ballots-cast_0.xls": {
    "state": "reachable",
    "status": 200
  },
  "https://www.sos.nh.gov/sites/g/files/ehbemt561/files/inline-documents/sonh/2024-pp-names-on-checklist_5.xls": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tbs-sct.canada.ca/pol/doc-eng.aspx?id=32592": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse-fr.eu/sites/default/files/TSE/documents/sem2026/eco_platforms/agarwal_google_search_aio.pdf": {
    "state": "not_found",
    "status": 404
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Abril/por-dentro-das-eleicoes-conheca-as-regras-sobre-uso-de-ia-na-campanha-eleitoral-de-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Agosto/eleicoes-2026-tse-fecha-acordo-com-elevenlabs-contra-deepfakes-de-voz": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Agosto/tse-cria-conselho-para-acompanhar-desinformacao-e-uso-de-inteligencia-artificial": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Agosto/tse-e-agu-firmam-acordo-de-boas-praticas-sobre-ia-nas-eleicoes-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Julho/eleicoes-2026-tse-e-plataformas-digitais-firmam-parcerias-para-ampliar-combate-a-desinformacao": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Julho/plataformas-tem-ate-16-de-agosto-para-apresentar-planos-de-conformidade-eleitoral-nas-campanhas-pela-internet": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/comunicacao/noticias/2026/Marco/eleicoes-2026-confira-as-principais-datas-do-calendario-eleitoral": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/eleicoes/sistema-de-alertas": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/legislacao/compilada/prt/2026/portaria-no-297-de-3-de-junho-de-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/legislacao/compilada/prt/2026/portaria-no-463-de-27-de-julho-de-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/legislacao/compilada/res/2019/resolucao-no-23-610-de-18-de-dezembro-de-2019": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/legislacao/compilada/res/2026/resolucao-no-23-751-de-26-de-fevereiro-de-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/legislacao/compilada/res/2026/resolucao-no-23-755-de-2-de-marco-de-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.tse.jus.br/legislacao/compilada/res/2026/resolucao-no-23-760-de-2-de-marco-de-2026": {
    "state": "reachable",
    "status": 200
  },
  "https://www.unesco.org/en/internet-trust/guidelines": {
    "state": "reachable",
    "status": 200
  },
  "https://www.venice.coe.int/webforms/documents/default.aspx?pdffile=CDL-AD%282025%29003-e": {
    "state": "reachable",
    "status": 200
  },
  "https://www.wired.com/story/slovakias-election-deepfakes-show-ai-is-a-danger-to-democracy/": {
    "state": "reachable",
    "status": 200
  },
  "https://www.youtube.com/watch?v=ZTyWOhF7Pto": {
    "state": "reachable",
    "status": 200
  },
  "https://www.youtube.com/watch?v=qIDhhVah4xE": {
    "state": "reachable",
    "status": 200
  },
  "https://www1.folha.uol.com.br/poder/2026/07/flavio-diz-ao-tse-que-video-de-ia-com-bolsonaro-e-legal-e-nao-engana-o-eleitorado.shtml": {
    "state": "reachable",
    "status": 200
  },
  "https://x.ai/news/grok-4": {
    "state": "reachable",
    "status": 200
  },
  "https://x.ai/news/grok-4-5": {
    "state": "reachable",
    "status": 200
  },
  "https://z.ai/blog/glm-4.5": {
    "state": "reachable",
    "status": 200
  },
  "https://z.ai/blog/glm-5": {
    "state": "reachable",
    "status": 200
  }
}
